export default {
  buybot: {
    bots: [],
    dailyCost: null,
  },
};
